import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import useAPI from "../hooks/useAPI";

import { useDispatch } from "react-redux";
import allActionsCat from "../state/categories/actions/index";

export default function useAdminCategories() {
  const dispatch = useDispatch();
  const localUser = JSON.parse(localStorage.getItem("kdmUser"));
  const superUser = localUser.sub === process.env.REACT_APP_ADMIN_UID;

  const { data, query: fetchData } = useAPI({
    type: "get",
    url: `categories`,
  });

  const { data: dataMerchants } = useAPI({
    type: "get",
    url: `merchants`,
  });

  const categories = useSelector((state) => {
    return state.categories.categories;
  });

  const [apiError, setApiError] = useState(false); //TODO:Placer dans useAPI

  const { query: deleteCategory } = useAPI({
    defer: true,
    type: "delete",
    url: "categories",
    body: {},
  });

  /**
   *
   * @param {string|array} id   @param id   ID(s) of categories to delete
   */
  const handleDelete = async (id) => {
    try {
      setApiError(false);
      await deleteCategory({
        url: `category/${id}`,
      });
      await fetchData();
    } catch (error) {
      throw error;
      // setApiError(true); // TODO: Voir si on garde ce truc, pas vraiment utile je crois
    }
  };

  const handleRefreshData = async () => {
    await fetchData();
  };

  useEffect(() => {
    if (data && data.categories) {
      dispatch(allActionsCat.categoryActions.fetchAllCat(data.categories));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    categories,
    merchants:
      dataMerchants && Array.isArray(dataMerchants.merchants)
        ? dataMerchants.merchants.map((m) => ({ id: m.id, name: m.referer }))
        : [],
    superUser,
    onDelete: handleDelete,
    onRefreshData: handleRefreshData,
    apiError,
  };
}
